import { render, staticRenderFns } from "./PedidoCuentaShowData.vue?vue&type=template&id=dd8a2b60"
import script from "./PedidoCuentaShowData.vue?vue&type=script&lang=js"
export * from "./PedidoCuentaShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports